@file:kotlin.js.JsExport
package com.narbase.letsgo.web.models.voiceassistant

object VoiceAssistantModels {

    const val DEFAULT_CHAT_MODEL = "gpt-4o"
    const val DEFAULT_TRANSCRIPTION_MODEL = "gpt-4o-transcribe"
    const val AUTO_DETECT_LANGUAGE = "auto"
    const val DEFAULT_TRANSCRIPTION_LANGUAGE = "ar"
    const val DEFAULT_TRANSCRIPTION_PROMPT =
        "مطار نواكشوط الدولي، تفرغ زينة، عرفات، لكصر، السبخة، دار النعيم، توجونين، الرياض، " +
                "الميناء، السوق، مستشفى، مسجد، فندق، جامعة نواكشوط، صيدلية، محطة، حي، شارع"

    val fallbackChatModels = arrayOf(
        "gpt-4o",
        "gpt-4o-mini",
        "gpt-4.1",
        "gpt-4.1-mini",
        "gpt-5",
        "gpt-5-mini",
    )

    val assistantNotes = arrayOf("OK", "NO_PLACE_FOUND", "UNCLEAR_SPEECH", "NOT_A_LOCATION")

    fun assistantNoteOrNull(note: String?) = note?.takeIf { it in assistantNotes && it != "OK" }

    val transcriptionLanguages = arrayOf(AUTO_DETECT_LANGUAGE, "ar", "fr", "en")

    val fallbackTranscriptionModels = arrayOf(
        "gpt-4o-transcribe",
        "gpt-4o-mini-transcribe",
        "whisper-1",
    )

    fun chatModelOrDefault(model: String) = model.ifBlank { DEFAULT_CHAT_MODEL }

    fun transcriptionModelOrDefault(model: String) = model.ifBlank { DEFAULT_TRANSCRIPTION_MODEL }

    fun transcriptionLanguageOrDefault(language: String) =
        language.takeIf { it in transcriptionLanguages } ?: DEFAULT_TRANSCRIPTION_LANGUAGE
}
